import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
const StarOutlineIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(SvgIcon, { ...props, ref, children: /* @__PURE__ */ jsxs("svg", { id: "favourite", xmlns: "http://www.w3.org/2000/svg", width: "23.096", height: "22.384", viewBox: "0 0 23.096 22.384", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Path_231",
        "data-name": "Path 231",
        fill: "currentColor",
        d: "M22.992,18.735a2,2,0,0,0-1.93-1.414H15.293l-1.817-5.573a2,2,0,0,0-1.927-1.409H11.54a2,2,0,0,0-1.925,1.424L7.851,17.321H2.034A2,2,0,0,0,.1,18.74a2.03,2.03,0,0,0,.742,2.292l4.707,3.436L3.74,30.026a2.03,2.03,0,0,0,.73,2.3,1.983,1.983,0,0,0,2.387.007l4.715-3.442,4.659,3.436a1.984,1.984,0,0,0,2.385.007,2.031,2.031,0,0,0,.745-2.288l-1.769-5.572,4.667-3.442A2.031,2.031,0,0,0,22.992,18.735Zm-1.531,1.188-5.456,4.024,2.067,6.512a.666.666,0,0,1-.248.763.651.651,0,0,1-.795,0L11.576,27.2,6.064,31.221a.651.651,0,0,1-.8,0,.666.666,0,0,1-.243-.765l2.121-6.506L1.638,19.925a.667.667,0,0,1-.247-.764.658.658,0,0,1,.644-.473h6.8L10.9,12.181a.657.657,0,0,1,.642-.475h0a.656.656,0,0,1,.643.47l2.123,6.512h6.748a.658.658,0,0,1,.643.471A.667.667,0,0,1,21.461,19.923Z",
        transform: "translate(0 -10.34)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Path_19759",
        "data-name": "Path 19759",
        fill: "currentColor",
        d: "M22.992,18.735a2,2,0,0,0-1.93-1.414H15.293l-1.817-5.573a2,2,0,0,0-1.927-1.409H11.54a2,2,0,0,0-1.925,1.424L7.851,17.321H2.034A2,2,0,0,0,.1,18.74a2.03,2.03,0,0,0,.742,2.292l4.707,3.436L3.74,30.026a2.03,2.03,0,0,0,.73,2.3,1.983,1.983,0,0,0,2.387.007l4.715-3.442,4.659,3.436a1.984,1.984,0,0,0,2.385.007,2.031,2.031,0,0,0,.745-2.288l-1.769-5.572,4.667-3.442A2.031,2.031,0,0,0,22.992,18.735Zm-1.531,1.188-5.456,4.024,2.067,6.512a.666.666,0,0,1-.248.763.651.651,0,0,1-.795,0L11.576,27.2,6.064,31.221a.651.651,0,0,1-.8,0,.666.666,0,0,1-.243-.765l2.121-6.506L1.638,19.925a.667.667,0,0,1-.247-.764.658.658,0,0,1,.644-.473h6.8L10.9,12.181a.657.657,0,0,1,.642-.475h0a.656.656,0,0,1,.643.47l2.123,6.512h6.748a.658.658,0,0,1,.643.471A.667.667,0,0,1,21.461,19.923Z",
        transform: "translate(0 -10.34)"
      }
    )
  ] }) });
});
export {
  StarOutlineIcon
};
//# sourceMappingURL=StarOutlineIcon.js.map
